import { type Group } from "@1js/pl-types";
import { Avatar, Option, makeStyles } from "@fluentui/react-components";
import * as React from "react";

export type GroupOptionProps = {
  group: Group;
};

const useStyles = makeStyles({
  optionContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
  },
  optionName: {
    marginLeft: "12px",
  },
});

export const GroupOption: React.FC<GroupOptionProps> = ({ group }) => {
  const image = group.AvatarUrl ? { src: group.AvatarUrl } : undefined;
  const styles = useStyles();
  return (
    <Option key={group.Id} text={group.DisplayName} value={group.Id}>
      <div className={styles.optionContainer}>
        <Avatar
          name={group.DisplayName}
          shape="square"
          image={image}
          color="colorful"
        />
        <div className={styles.optionName}>{group.DisplayName}</div>
      </div>
    </Option>
  );
};
